const allMixins = [
    {
        name: "FajnyColors",
        effect: "Short code for every colors of Fajny CSS",
        variables: "$color",
        example: 'Mixins.FajnyColors({\n    $color: "secondary-500",\n})',
    },
    {
        name: "ColorsShort",
        effect: "Short names for main colors",
        variables: "$color",
        example: 'Mixins.ColorsShort({\n    $color: "secondary",\n})',
    },
    {
        name: "AllColors",
        effect: "Function joining FajnyColors and ColorsShort",
        variables: "$color",
        example: 'Mixins.AllColors({\n    $color: "success",\n})',
    },
    {
        name: "ColorsHoverDefault",
        effect: "Default colors for element which change colors on hover",
        variables: "$color (To add inside the component and not the styles)",
        // eslint-disable-next-line
        example: "color: ${Mixins.ColorsHoverDefault}",
    },
    {
        name: "ColorsHoverHover",
        effect: "Hover colors for element which change colors on hover",
        variables: "$color (To add inside the component and not the styles)",
        // eslint-disable-next-line
        example: "&:hover {\n    color: ${Mixins.ColorsHoverHover};\n}",
    },
    {
        name: "ColorsHoverActive",
        effect: "Active colors for element which change colors on hover",
        variables: "$color (To add inside the component and not the styles)",
        // eslint-disable-next-line
        example: "&:active {\n    color: ${Mixins.ColorsHoverActive};\n}",
    },
    {
        name: "Grid",
        effect: "Add a CSS grid",
        variables:
            "$inline, $col, $gap, $columnGap, $rowGap, $justifyItems, $alignItems, $justifyContent, $alignContent, $padding",
        // eslint-disable-next-line
        example: '${Mixins.Grid({ \n    $col: 4, \n    $gap: "s" \n})}',
    },
    {
        name: "Flexbox",
        effect: "Add a flexbox",
        variables:
            "$inline, $direction, $wrap, $justify, $align, $gap, $rowGap, $columnGap",
        example:
            // eslint-disable-next-line
            '${Mixins.Flexbox({ \n    $inline: true, \n    $align: "center", \n    $justify: "flex-end", \n})}',
    },
    {
        name: "Icon",
        effect: "Add an icon",
        variables: "$name, $color, $size",
        example:
            // eslint-disable-next-line
            '&:before { \n    ${Mixins.Icon({ \n        $name: "chevron-down-solid", \n        $color: "primary", \n        $size: 24, \n    })}; \n}',
    },
]

export default allMixins
